<template>
  <span class="bio-line" :class="classObj"
    ><template v-if="expanded && startsWithSpace"
      >&nbsp;</template
    ><span v-if="expanded" class="bio-line__text" @click.prevent="toggle">{{
      trimmedText
    }}</span
    ><template v-if="expanded && image"
      >&nbsp;<img
        :src="image.url"
        :width="image.width"
        :height="image.height"
        :class="{ invisible: imageExpanded }"
        alt=""
        class="bio-line__image"
        @click.prevent="expandImage"/><big-image
        v-if="imageExpanded"
        :src="image.url"
        @close="closeImage"/></template
    ><bio-line
      v-bind="line"
      v-for="(line, i) in subtext"
      :key="`subline-${i}`"
      :expanded="subexpanded"
  /></span>
</template>

<script>
import BigImage from '@/components/BigImage.vue'

export default {
  name: 'BioLine',

  components: {
    BigImage
  },

  props: {
    expanded: {
      default: false,
      type: Boolean
    },

    image: {
      default: () => {},
      type: Object
    },

    text: {
      default: null,
      type: String,
      required: true
    },

    subtext: {
      default: () => [],
      type: Array
    }
  },

  data: () => ({
    subexpanded: false,
    imageExpanded: false
  }),

  computed: {
    classObj() {
      return {
        'is-expandable': this.subtext.length > 0,
        'is-expanded': this.subexpanded,
        'is-not-expanded': !this.subexpanded
      }
    },

    startsWithSpace() {
      return this.text[0] === ' '
    },

    trimmedText() {
      return this.text.trim()
    }
  },

  methods: {
    toggle() {
      this.subexpanded = !this.subexpanded
    },

    expandImage() {
      this.imageExpanded = true
    },

    closeImage() {
      this.imageExpanded = false
    }
  }
}
</script>

<style>
.bio-line.is-expandable > .bio-line__text {
  cursor: pointer;
  text-decoration: underline;
}

.bio-line.is-expanded > .bio-line__text {
  text-decoration: none;
}

.bio-line__image {
  cursor: pointer;
}
</style>
